import { gql } from 'graphql-request';
export const MARKET_STATE_EXPORT_REPORT_FRAGMENT = gql`
	fragment MarketStateExportReportFields on MarketStateExportReport {
		id
		companyHotelId
		name
		creationDate
		reportType
		scope
		period
		fromDate
		toDate
		filter {
			roomTypes
            provider
            platform
            region
            ratesType
            nights
            guests
            airportCode
            meal
            refunding
            competitorTagIds
		}
	}
`;

export const REPORT_EXECUTION_FRAGMENT = gql`
	fragment ReportExecutionFields on ReportExecution {
		id
		companyHotelId
		reportId
		reportType
		source
		deliveryExecutionId
		profileId
		creationDate
		executionDate
		finishedDate
		state
		reason
		effectiveFormat
		filename
	}
`;

export const MARKET_STATE_EXPORT_REPORT_EXECUTION_FRAGMENT = gql`
	${MARKET_STATE_EXPORT_REPORT_FRAGMENT}
	${REPORT_EXECUTION_FRAGMENT}
	fragment MarketStateExportReportExecutionFields on MarketStateExportReportExecution {
		execution {
			...ReportExecutionFields
		}
		report {
			...MarketStateExportReportFields
		}
	}
`;

export const MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_FRAGMENT = gql`
	${MARKET_STATE_EXPORT_REPORT_FRAGMENT}
	fragment MarketStateExportDeliveryScheduleFields on MarketStateExportDeliverySchedule {
		schedule {
			id
			companyHotelId
			creationDate
			state
			recipients
			dayOfMonth
			weekdays
			time
			scheduleType
			reportIds
			nextExecutionDate
			timezone
		}
		reports {
			...MarketStateExportReportFields
		}
	}
`;
